import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Platform } from 'ionic-angular';
import * as debug from 'debug';

@Component({
  selector: 'image-metadata-wrapper',
  templateUrl: 'image-metadata-wrapper.html',
})
export class ImageMetadataWrapperComponent {
  log = debug('debug:app:ImageMetadataWrapperComponent');

  @Input()
  metadata: any;

  @Input()
  class = '';

  @Input()
  allowOpen = false;

  @Input()
  url: string;

  @Input()
  inPhotoSlider = false;

  @Input()
  isVideo = false;

  @Output()
  opened = new EventEmitter();

  @Output()
  loaded = new EventEmitter();

  isAndroid = false;
  useVideo = false;

  constructor(public platform: Platform) {
    this.isAndroid = this.platform.is('android');
  }

  ngOnInit() {
    const videoRegex = /(.mp4|.webm|.ogg)$/i;
    if ((this.isAndroid && videoRegex.test(this.url)) || this.isVideo)
      this.useVideo = true;
  }

  ngOnChanges() {
    this.log('change url', this.url);
    this.log('change metadata', this.metadata);
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/components/image-metadata-wrapper/image-metadata-wrapper.ts